import StatsBox from './StatsBox';
export default StatsBox;


// WEBPACK FOOTER //
// ./src/containers/dashboard/components/statsBox/index.js